import { render, staticRenderFns } from "./PartyEducation.vue?vue&type=template&id=42484abe&scoped=true&"
import script from "./PartyEducation.vue?vue&type=script&lang=js&"
export * from "./PartyEducation.vue?vue&type=script&lang=js&"
import style0 from "./PartyEducation.vue?vue&type=style&index=0&id=42484abe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42484abe",
  null
  
)

export default component.exports